<mat-dialog-content>
    <h1 class="f-18" mat-dialog-title>
        @if (memory) {
            Edit
        }
        @if (!memory) {
            New
        }
        Album
    </h1>
    <form [formGroup]="memoryForm" class="fieldContainer w-100 mt-10 pt-10">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Title</mat-label>
            <input formControlName="title" matInput required>
            <app-emoji-menu [form]="memoryForm" [input]="'title'" matSuffix></app-emoji-menu>
            @if (memoryForm.controls['title'].hasError('required')) {
                <mat-error>A title is required</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Description</mat-label>
            <textarea #description formControlName="description" matInput
                      maxlength="400"></textarea>
            <app-emoji-menu [form]="memoryForm" [input]="'description'" matSuffix></app-emoji-menu>
            <mat-hint align="end">{{ description?.value?.length }} / 400</mat-hint>
        </mat-form-field>


        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Who was there</mat-label>
            <input formControlName="attendees" matInput placeholder="Who was there">
        </mat-form-field>
        @if (allowsLocation) {
            <div id="locationContainer">
                <mat-form-field appearance="outline" class="w-100 noBottomPadding">
                    <mat-label>Location</mat-label>
                    <input #placesInput formControlName="address" matInput placeholder="{{memory?.address}}">
                </mat-form-field>
            </div>
        }
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Choose a date</mat-label>
            <input [matDatepicker]="picker" [max]="maxDate" [min]="minDate" formControlName="date" matInput>
            <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (memoryForm.controls['date'].hasError('matDatepickerParse')) {
                <mat-error>
                    Invalid date format. Please use DD/MM/YYYY.
                </mat-error>
            }
        </mat-form-field>

        <div>
            <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>Tags</mat-label>
                <input #tagInput [formControl]="tagSearchControl"
                       [matAutocomplete]="auto"
                       [matChipInputFor]="chipList"
                       matInput
                       placeholder="Select Tags">
                <mat-autocomplete #auto="matAutocomplete"
                                  (optionSelected)="selectTag($event.option.value)">
                    @for (tag of (filteredTags | async) ?? []; track tag) {
                        @if (!checkIfInArray(tag.id, this.selectedTags)) {
                            <mat-option
                                    [value]="tag.id">
                                {{ tag.name }}
                            </mat-option>
                        }
                    }
                </mat-autocomplete>
                <mat-chip-grid #chipList aria-label="Tags Selection">
                    @for (tag of this.tags; track tag) {
                        @if (checkIfInArray(tag.id, this.selectedTags)) {
                            <mat-chip (removed)="removeTag(tag.id)"
                                      class="smChip">
                                {{ tag.name }}
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip>
                        }
                    }
                </mat-chip-grid>
            </mat-form-field>
        </div>


    </form>
</mat-dialog-content>
<mat-dialog-actions class="flex-space-around">
    <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" color="warn" mat-dialog-close
            mat-raised-button>
        Cancel
    </button>
    <button (click)="saveDetails()" (keyup.enter)="saveDetails()" [disabled]="loading || memoryForm.invalid"
            color="primary"
            mat-raised-button>
        Save
    </button>
</mat-dialog-actions>
